<script>
    // svelte

    // d3
    import { feature } from 'topojson-client';
    import { geoPath, geoAlbersUsa } from 'd3-geo';
    import { scaleLinear } from "d3-scale";
    import { extent } from "d3-array";

    // components
    import LazyLoad from './LazyLoad.svelte';

    // other imports
    import { apdate } from 'journalize';

    export let data;
    export let title;
    export let date;
    export let showTitle;
    export let showDate;
    export let includeKey;
    export let showCities;

    let visible = false;
    import cityList from './usCities.js';

    // Configure the mapping tools for cities
    const mercator = geoAlbersUsa()
        .scale(1300)
        .translate([487.5, 305]);
    
        const path = geoPath().projection(mercator);

    //data
    import states from './state-boundaries.json';

    const blobs = feature(data, data.objects.droughtmap);

    const namesExtent = extent(blobs.features, d => d.properties.DM);

    let colorScale = () => {};

    colorScale = scaleLinear()
    .domain(['','0','1','2','3','4'])
      .range(['#ffffff','#f5df8b','#deba6a','#c48237','#c26170','#7b222c']);

    const key = [
        {
            "DM": "none",
            "name": "No drought"
        },        
        {
            "DM": 0,
            "name": "Abnormally dry"
        },
        {
            "DM": 1,
            "name": "Moderate drought"
        },
        {
            "DM": 2,
            "name": "Severe drought"
        },
        {
            "DM": 3,
            "name": "Extreme drought"
        },
        {
            "DM": 4,
            "name": "Exceptional drought"
        }
    ]
  </script>
<LazyLoad bind:visible on:visible={() => console.log(`Load ${title}`)}> 

  <div class="svg-container">
    {#if showTitle }
        <div class="chart-headline">{title}</div>
    {/if}
    {#if includeKey == true}
        <div class="key">
            {#each key as k }
                <div class="key-item">
                    <span class=d{k.DM}></span> {k.name}
                </div>
            {/each}
        </div>  
    {/if}
    {#if showDate }
        <div class="chart-subheadline">{apdate(date)}</div>
    {/if}
    <svg viewBox="0 0 975 610" role="graphics-document">
        <g class="region-layer" role="graphics-object">
            {#each blobs.features as feature}
                <path
                    d={path(feature)}
                    class="drought-level"
                    role="graphics-symbol"
                    fill="{colorScale(feature.properties.DM)}"
                    stroke="#fff"
                    stroke-width="0"  />
            {/each}
        </g>
        <g class="state-layer" role="graphics-object">
            {#each states.features as obj}
                <path
                    d={path(obj)}
                    class="state"
                    role="graphics-symbol"
                    fill="none"
                    stroke="#666"
                    stroke-width="0.5"
                    style="mix-blend-mode: multiply;"
                    />
            {/each}      
        </g>
        {#if showCities}
            <g class="us-cities" role="graphics-object">
                {#each cityList as obj}
                    <g
                    data-name={obj.name}
                    transform="translate({mercator([obj.long, obj.lat])})"
                    >
                    <circle r="4" class="city" role="graphics-symbol" />
                    <text
                        class="halo"
                        dx={obj.orientation == 'right' ? '8px' : '-8px'}
                        dy="6px"
                        text-anchor={obj.orientation == 'right' ? 'start' : 'end'}
                    >
                        {obj.name}
                    </text>
                    <text
                        class="text"
                        dx={obj.orientation == 'right' ? '8px' : '-8px'}
                        dy="6px"
                        text-anchor={obj.orientation == 'right' ? 'start' : 'end'}
                    >
                        {obj.name}
                    </text>
                    </g>
                {/each}
            </g>
        {/if}         
    </svg>
  </div>
</LazyLoad>